import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Checkout from "@/pages/Checkout";
import Unlock from "@/pages/Unlock";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";
import AffiliateStats from "@/pages/AffiliateStats";
import Reviews from "@/pages/Reviews";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1.05 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/unlock" element={<Unlock />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/seller" element={<AffiliateStats />} />
        <Route path="/affiliate/:code" element={<AffiliateStats />} />
        <Route path="/terms" element={<Legal kind="terms" />} />
        <Route path="/refund-policy" element={<Legal kind="refund" />} />
        <Route path="/risk-disclaimer" element={<Legal kind="disclaimer" />} />
      </Routes>
      <Toaster theme="light" position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
